import request from '@/utils/requestold'


export function getCourse(id) {
    return request({
      url: '/api/platform/course/'+id,
      method: 'get',
    })
  }
  export function getCourseList(params) {
    return request({
      url: '/api/admin/course_set/normal/index',
      method: 'get',
      params
    })
  }

  /**
   * 竞练系统首页数据获取
   * @param {*} data 
   */
  export function getHomeIndex(data){
    return request({
      url: '/api/contest/contest_index',
      method: 'post',
      data
    })
   }


  /**
   * 获取训练排行榜日/周/总数据
   */
   export function getTrainingRankList(data){
    return request({
      url: '/api/contest/index_rank',
      method: 'post',
      data
    })
   }